<template>
  <div class="jobDetail breadcrumbs-absolute aboutUs siteMapPage FeedbackPage" :class="{'aboutUsPC':$store.state.innerWidth>768}">
    <div class="header jobPosingSearch row flexHeader flexHeaderJia200">
    <Breadcrumbs></Breadcrumbs>
        <div class="warp-mask"></div>
        <div class="job-containers-center col-sm-10 col-md-8 padLeft-0 padRight-0">
            <h1 class="Bold" :class="{'font-size-60':$store.state.innerWidth>768}"> {{$t('message.Feedback')}}</h1>
        </div>
    </div>
    <div class="opp-contain row">
      <div class="about-pc marin-b-100">
        <div class="descriptionPC-right col-sm-12 col-md-12 padLeft-0 padRight-0" >
            <div class="contentGroup padding-b-50">
                
                   <div class="page1" >
                     <div class="row">
                        <div class="col-sm-12 f-desc">
                           {{$t('message.feedbackDesc')}}
                        </div>
                        <!-- <div class="col-sm-12 SemiBold f-info">
                           {{$t('message.Contact information')}}
                        </div>
                        <div class="col-sm-6">
                            <div class="f-label SemiBold">
                              {{$t('message.Email')}}
                            </div>
                            <div class="f-input col-sm-12">
                                <input  maxlength='200' :aria-label="$t('message.Please enter your email')" v-bind:placeholder="$t('message.Please enter your email')" type="email" v-model="email"></input>
                            </div>
                        </div>
                        <div class="col-sm-12 SemiBold f-info">
                           {{$t('message.Feedback form')}}
                        </div>
                        <div class="col-sm-6">
                            <div class="f-label SemiBold">
                                {{$t('message.Types of user')}}<span class="red">*</span>
                            </div>
                            <div class="f-input col-sm-12">
                                <div @click="openUserTypeEvent">
																	<a href="javascript:;">
                                  	<input v-bind:placeholder="$t('message.Please select the type of user')" role="combobox" :aria-label="$t('message.Please select the type of user')" type="text" disabled v-model="userType" />
																	</a>
																</div>
                                <b class="i-right"><i aria-hidden="true" class="icon-arrow-down mainColor"></i></b>
                                <div class="criteria-content can-scrol" :class="{'show':showUserTypeGroup}">
                                    <div class="ulGroup">
                                        <ul>
                                            <li @click="selectUserType($t('message.Student'))" role="option" :aria-label="$t('message.Student')">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.Student')}}</a>
                                            </li>
                                            <li @click="selectUserType($t('message.Job seeker'))" role="option" :aria-label="$t('message.Job seeker')">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.Job seeker')}}</a>
                                            </li>
                                            <li @click="selectUserType($t('message.Employee'))" role="option" :aria-label="$t('message.Employee')">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.Employee')}}</a>
                                            </li>
                                            <li @click="selectUserType($t('message.CareerEducationCounsellor'))" role="option" :aria-label="$t('message.CareerEducationCounsellor')">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.CareerEducationCounsellor')}}</a>
                                            </li>
                                            <li @click="selectUserType($t('message.Others'))" role="option" :aria-label="$t('message.Others')">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.Others')}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="f-label SemiBold">
                                {{$t('message.Age group')}}<span class="red">*</span>
                            </div>
                            <div class="f-input col-sm-12 ">
                                <div @click="openAgeEvent">
																	<a href="javascript:;">
                                    <input role="combobox" :aria-label="$t('message.Please select the age group')" v-bind:placeholder="$t('message.Please select the age group')" type="text" v-model="userAge" disabled />
																	</a>
                                </div>
                                <b class="i-right"><i aria-hidden="true" class="icon-arrow-down mainColor" ></i></b>
                                <div class="criteria-content can-scrol" :class="{'show':showAgeGroup}">
                                    <div class="ulGroup">
                                        <ul>
                                            <li @click="selectUserAge($t('message.Below 18'))" role="option" :aria-label="$t('message.Below 18')">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.Below 18')}}</a>
                                            </li>
                                            <li @click="selectUserAge('18-25')" role="option" aria-label="18-25">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">18-25</a>
                                            </li>
                                            <li @click="selectUserAge('26-29')" role="option" aria-label="26-29">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">26-29</a>
                                            </li>
                                            <li @click="selectUserAge('30-39')" role="option" aria-label="30-39">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">30-39</a>
                                            </li>
                                            <li @click="selectUserAge('40-49')" role="option" aria-label="40-49">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">40-49</a>
                                            </li>
                                            <li @click="selectUserAge('50-59')" role="option" aria-label="50-59">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">50-59</a>
                                            </li>
                                            <li @click="selectUserAge($t('message.60 or above'))" role="option" :aria-label="$t('message.60 or above')">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.60 or above')}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="f-label SemiBold">
                                {{$t('message.Type of feedback')}}<span class="red">*</span>
                            </div>
                            <div class="f-input col-sm-12">
                                <div @click="openGenderEvent">
																	<a href="javascript:;" style="color: inherit; text-decoration:none">
                                  	<input role="combobox" :aria-label="$t('message.Please select type of feedback')" v-bind:placeholder="$t('message.Please select type of feedback')" type="text" v-model="typeOfFeedback" disabled  ></input>
																	</a>
																</div>
                                <b class="i-right"><i aria-hidden="true" class="icon-arrow-down mainColor"></i></b>
                                <div class="criteria-content can-scrol" :class="{'show':showGenderGroup}">
                                    <div class="ulGroup">
                                        <ul>
                                            <li role="option" :aria-label="$t('message.Enquiries')" @click="selecttypeOfFeedback($t('message.Enquiries'))">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.Enquiries')}}</a>
                                            </li>
                                            <li role="option" :aria-label="$t('message.Outdated inaccurate information')" @click="selecttypeOfFeedback($t('message.Outdated inaccurate information'))">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.Outdated inaccurate information')}}</a>
                                            </li>
                                            <li role="option" :aria-label="$t('message.Suggestions and recommendations')" @click="selecttypeOfFeedback($t('message.Suggestions and recommendations'))">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.Suggestions and recommendations')}}</a>
                                            </li>
                                            <li role="option" :aria-label="$t('message.Collaboration opportunities')" @click="selecttypeOfFeedback($t('message.Collaboration opportunities'))">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.Collaboration opportunities')}}</a>
                                            </li>
                                            <li role="option" :aria-label="$t('message.Others')" @click="selecttypeOfFeedback($t('message.Others'))">
                                            	<a href="javascript:;" style="color: inherit; text-decoration:none">{{$t('message.Others')}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="f-label SemiBold">
                                {{$t('message.Related Page')}}
                            </div>
                            <div class="f-input col-sm-12">
                                <textarea :aria-label="$t('message.Please enter message')" v-bind:placeholder="$t('message.Please enter message')" type="text" maxLength="500" v-model="relatedPage"></textarea>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="f-label SemiBold">
                                {{$t('message.Message')}}<span class="red">*</span>
                            </div>
                            <div class="f-input col-sm-12">
                                <textarea :aria-label="$t('message.Please enter message')" v-bind:placeholder="$t('message.Please enter message')" type="text" maxLength="1000"  v-model="message"></textarea>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="f-input col-sm-12">
                                <vue-recaptcha
                                  ref="recaptcha"
                                  @verify="onCaptchaVerified"
                                  @expired="onCaptchaExpired"
                                  sitekey="6Lc-i8AUAAAAAI6HtMbEaCCAgL8bMhYsVx3_qb4z">
                                </vue-recaptcha>
                            </div>
                        </div>
                        <div class="col-sm-12 submitBtn">
                            <div 
                              class="btn btn-disabled" 
                              style="max-width:250px;" 
                              v-if="!(recaptchaToken&&userType&&userAge&&typeOfFeedback&&message&&checkEmail)"
                              role="button"
                              :aria-label="$t('message.Submit')"
                            >
                              {{$t('message.Submit')}}
                            </div>
                            <div 
                              class="btn btn-primary" 
                              style="max-width:250px;"  
                              @click="submitEvent"
                              v-else
                              role="button"
                              :aria-label="$t('message.Submit')"
                            >
															<a href="javascript:;" style="color: inherit; text-decoration: none">{{$t('message.Submit')}}</a>
														</div>
                        </div> -->
                     </div>
                   </div>
                   <img class="bgImg2 noSelect" v-if="$store.state.innerWidth<=1120" src="../images/deco-18.png" />
            </div>
        </div>
        <div class="mask" @click="hidePopup" :class="{'show':(showGenderGroup||showAgeGroup||showUserTypeGroup)}"></div>
      </div>
      <img class="bgImg noSelect" v-if="$store.state.innerWidth>1120" src="../images/deco-18.png" />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import VueRecaptcha from 'vue-recaptcha';
import { EventBus } from "@/javascripts/eventBus.js";

export default {
  name:"feedback",
  data() {
    return {
      isOpen: false,
      active:"",
      showGenderGroup:false,
      showAgeGroup:false,
      showUserTypeGroup:false,
      userType:"",
      userAge:"",
      typeOfFeedback:"",
      phone:"",
      email:"",
      status:"",
      recaptchaToken:"",
      telNumber:"",
      address:"",
      message:"",
      relatedPage:"",
      checkEmail:true,
        }
    },   
  props:[
  'logGaEvent'
  ],
  components: {
    Breadcrumbs,
    VueRecaptcha 
  },
  created() {},
    watch:{
        email (news,old) {
          var reg = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
          if(reg.test(news)){
            this.checkEmail = true;
          }else{
            this.checkEmail = false;
          }
          if(news == ""){
            this.checkEmail = true;
          }
        },
    },
  methods: {
    openGenderEvent:function(){
        this.hidePopup();
        this.showGenderGroup = !this.showGenderGroup;
    },
    openAgeEvent:function(){
        this.hidePopup();
        this.showAgeGroup = !this.showAgeGroup;
    },
    openUserTypeEvent:function(){
        this.hidePopup();
        this.showUserTypeGroup = !this.showUserTypeGroup;
    },
    selectUserType:function(type){
        this.hidePopup();
        this.userType = type;
    },
    selectUserAge:function(age){
        this.hidePopup();
        this.userAge = age;
    },
    selecttypeOfFeedback:function(Gender){
        this.hidePopup();
        this.typeOfFeedback = Gender;
    },
    hidePopup:function(){
        this.showGenderGroup = false;
        this.showAgeGroup = false;
        this.showUserTypeGroup = false;
    },
    onCaptchaVerified: function (recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },
    onCaptchaExpired: function () {
        this.recaptchaToken = ""
      this.$refs.recaptcha.reset();
    },
    submitEvent:function(){
      let Base64 = require('js-base64').Base64
      var that = this;
      if(!this.email){
        this.email = 'hkmip.info@gmail.com';
      }

      this.logGaEvent('userClick','Feedback',this.email)
      this.api.sendEmail(
        {
          recaptchaToken: this.recaptchaToken,
          email:this.email,
          usersType:this.userType,
          ageGroup:this.userAge,
          typeOfFeedback:this.typeOfFeedback,
          relatedPage:Base64.encode(this.relatedPage),
          message:Base64.encode(this.message)
        },
        function(data) {
          that.recaptchaToken = "";
          that.email = "";
          that.userType = "";
          that.userAge = "";
          that.typeOfFeedback = "";
          that.relatedPage = "";
          that.message = "";
          that.$refs.recaptcha.reset();
          EventBus.$emit('success', { title: that.$i18n.t("message.sendSuccess") })
        }
      );
    }
  },
  mounted() {
    var that = this;
    setTimeout(function(){
      that.$store.state.mate.title = that.$i18n.t("message.Feedback")+' - talent.gov.hk - '+that.$i18n.t("message.Default Page Title");
    })
    this.$store.state.selectMenu = 0;
      // this.$store.state.mate.title = this.$i18n.t("message.Feedback")+" - talent.gov.hk - "+this.$i18n.t("message.Default Page Title")
    var that = this;
  }
};
</script>